<template>
  <div>
    <video-background
      :src="'content/front/vje_front_video_updated.mp4' | blob_url"
      :poster="'content/front/poster_img.png' | blob_url"
      style="max-height: 100vh; height: 100vh"
      overlay="linear-gradient(45deg,#00000088,#00000088)"
    >
      <div class="container">
        <img
          src="@/assets/frontend/images/vje_logo.png"
          alt="Virtual Job Experience logo"
          id="logo"
        />

        <div class="buttons_wrapper">
          <p class="copy">
            Please log in to your school secure area to access Virtual Job Experience
          </p>
          <!-- <div class="button_wrapper">
            <router-link to="/student/login">
              <vs-button color="#fff" type="border" size="large" class="home_btn"
                >Student Login
              </vs-button>
            </router-link>
          </div>
          <div class="button_wrapper">
            <vs-button color="#fff" type="border" size="large" class="home_btn" to="/teacher/login">Teacher Login
              </vs-button>
          </div> -->
        </div>
      </div>
    </video-background>
  </div>
</template>

<script>
import VideoBackground from 'vue-responsive-video-background-player';

export default {
  components: {
    VideoBackground,
  },
};
</script>

<style scoped>
#logo {
  width: 200px;
  margin: 20px 0;
}

.buttons_wrapper {
  text-align: center;
  top: 50vh;
  position: absolute;
  margin-top: 0;
  width: 100%;
  left: 0;
  padding: 0 15px;

  .copy {
    color: #fff;
    font-size: 18px;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  #logo {
    width: 150px;
    margin: 15px 0;
  }
}

@media screen and (max-width: 767px) {
  #logo {
    width: 130px;
    margin: 15px 0;
  }

  .buttons_wrapper {
    top: 40vh;
  }
}
</style>
